export const ru = {
    collapse: 'Свернуть',
    expand: 'Развернуть',
    more: 'еще {count}',
};
